import { createSlice } from "@reduxjs/toolkit";
import { fetchCompletedTask } from "./thunk";

interface MyTeamState {
  List: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: MyTeamState = {
  List: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const completedTaskSlice = createSlice({
  name: "completedTask",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompletedTask.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompletedTask.fulfilled, (state, action) => {
        state.loading = false;
        state.List = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchCompletedTask.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Field Engineer Completed Task";
      });
  },
});

export default completedTaskSlice.reducer;
